import { styled } from '@mui/material';
import { Button, Card, Form, Input, Modal, Popconfirm, Table, message } from 'antd';
import React, { Fragment, useState } from 'react';
import { useAddBrand, useBrandList, useDeleteBrand } from '../../../requests/misc';


const ContentBox = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: { margin: '16px' },
}));

const BrandsFragments = () => {


    const { mutate, isLoading } = useAddBrand();
    const { data } = useBrandList();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10)

    const { mutate:deleteAction }  = useDeleteBrand();

    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState("");

    function AddBrand(){
        mutate({ title: title }, {
            onSuccess:() => {
                message.success("Brand Added Successfully");
                setTitle("");
                setIsOpen(false);
            }
        });
    }
    
      
      const columns = [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          render: (text, record, index) => (page - 1) * pageSize + index + 1,

        },
        {
          title: 'Brand Name',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '*',
          dataIndex: 'id',
          key: 'id',
          render:(id) => <>
            <Popconfirm
            title="Are you sure delete this brand?"
            onConfirm={e => {
                    deleteAction({ id: id }, {
                        onSuccess:e => {
                            message.success("Brand Deleted Successfully");
                        }
                    })
                }
            }

            >
                <Button danger>X</Button>
            </Popconfirm>
          </>
        },
      ];


    return (
        <Fragment>
            <ContentBox className="Brands">
                <Card
                    extra={<Button onClick={() => setIsOpen(true)}>Add Brand</Button>}
                    title="Brands"
                >
                     <Table
                     pagination={{
                        onChange:(a,b) => {
                            setPage(a);
                            setPageSize(b)
                        }
                     }}
                     dataSource={data?.brands ?? []} columns={columns} size='small' />
                </Card>
            </ContentBox>

            <Modal  
                okText="Add"
                title="Add Brand" 
                open={isOpen} 
                onOk={AddBrand} 
                onCancel={() => setIsOpen(false)}
                centered={true}
            >
                <Form layout="vertical">
                    <Input 
                        onChange={e => setTitle(e.target.value)}
                        value={title}
                    />
                </Form>
            </Modal>
        </Fragment>
    );
};

export default BrandsFragments;
